<script setup lang="ts">
const showArrow = ref(false);
const isMounted = ref(false);

const handlerScroll = () => (showArrow.value = window.scrollY > 50);

onMounted(() => {
    if (import.meta.client) {
        window.addEventListener('scroll', handlerScroll);
        isMounted.value = true;
    }
});

onBeforeUnmount(() => {
    if (import.meta.client) {
        window.removeEventListener('scroll', handlerScroll);
    }
});

const scrollToTop = () => {
    document.body.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
    });
};
</script>

<template>
    <Transition name="fade">
        <button
            v-show="showArrow"
            type="button"
            class="ui-up-arrow"
            @click="scrollToTop"
        >
            <template v-if="$slots.caption">
                <span class="ui-up-arrow__caption">
                    <slot name="caption"></slot>
                </span>
            </template>

            <template v-if="$slots.icon">
                <span class="ui-up-arrow__icon">
                    <slot name="icon"></slot>
                </span>
            </template>
        </button>
    </Transition>
</template>

<style scoped lang="scss">
@import 'styles/ui-up-scroll-btn';
</style>
